import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var NoPermission =
/** @class */
function (_super) {
  __extends(NoPermission, _super);

  function NoPermission() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NoPermission = __decorate([Component({
    name: 'NotBought',
    components: {}
  })], NoPermission);
  return NoPermission;
}(Vue);

export default NoPermission;